import React, { useState,  useEffect } from 'react';
import "./DashBoard.css";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { Avatar, IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import FaceIcon from '@material-ui/icons/Face';
import BusinessIcon from '@material-ui/icons/Business';
import AddIcon from '@material-ui/icons/Add';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VideocamIcon from '@material-ui/icons/Videocam';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import firebase from "firebase";
import db from './firebase';
import Post from "./Post";
import StoryReel from "./StoryReel";

function DashBoardForm() {
    const [{user}, dispatch] = useStateValue();
    const [input, setInput] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [post, setPost] = useState([]);
    const handleSubmit = (e) => {
         e.preventDefault();
          
//DB stuff
db.collection("users").doc(user?.uid).set({
    bizname: input,
   
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    profilePic: user?.photoURL,
    username: user?.displayName,
    image: imageUrl,
})

setInput("");
setImageUrl("");



};

    return (
        
              <div className="info__form">

         <div className="messageSender">
            <div className="messageSender__top">
                <Avatar src={user?.photoURL} />

                <form>
                    <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    className="messageSender__input" 
                    placeholder={"Your Thoughts"}
                    
                    />

                    <input
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                    placeholder="Share your Photos URL"  />

                    <button onClick={handleSubmit} type="submit">
                        hidden submit
                    </button>
                </form>

            </div>
            


            <div className="messageSender__bottom">
<div className="messageSender__option">
<VideocamIcon style={{ color: "red" }} />
<h3>Live Review</h3>
</div>

<div className="messageSender__option">
<PhotoLibraryIcon style={{ color: "green" }} />
<h3>Photos/ videos</h3>
</div>

<div className="messageSender__option">
<InsertEmoticonIcon style={{ color: "yellon" }} />
<h3>Fav</h3>
</div>

<div>

</div>

            </div>

        </div>
  
 


            </div>
      
    )
}

export default DashBoardForm




